module.exports = __webpack_public_path__ + "static/media/login-hero.aa25969b.jpg";